<template>
    <div class="fluid">
        <h1 class="app-title">E-mail's ao Devedor</h1>
        <b-card title="Dados Gerais">
            <b-row class="mb-0 mt-4">
                <b-col md="4">
                    <p class="mb-2">
	                    Endereço Email Requisição CES - Subfluxo principal:
                        <span class="text-danger">*</span>
                    </p>
                </b-col>
                <b-col md="3" style="margin-top: -8px;">
                    <b-col>
                        <b-form-input v-model="parametros.emailCes" type="text" id="email" maxlength="100"
                                      @keyup="parametros.emailCes = removeSpecialCharactersGeralVirgula(parametros.emailCes)"/>
                        <div v-if="!paymentValidations.emailCes.valid" class="invalid-message">Campo Obrigatório.</div>
                    </b-col>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col md="4">
                    <p class="mb-2">
	                    Endereço Email Requisição CES - Subfluxo transferência:
                        <span class="text-danger">*</span>
                    </p>
                </b-col>
                <b-col md="3" style="margin-top: -8px;">
                    <b-col>
                        <b-form-input v-model="parametros.emailCesTransf" type="text" id="email" maxlength="100"
                                      @keyup="parametros.emailCesTransf = removeSpecialCharactersGeralVirgula(parametros.emailCesTransf)"/>
                        <div v-if="!paymentValidations.emailCesTransf.valid" class="invalid-message">Campo Obrigatório.</div>
                    </b-col>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        E-mail de encaminhamento do boleto, termo de parcelamento e memória de cálculo da Requisição:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo(
                               'E-mail de encaminhamento do boleto, termo de parcelamento e memória de cálculo da Requisição',
                               'Texto a ser incluído no e-mail de encaminhamento ao devedor do boleto, termo de parcelamento e memória de cálculo relativo à Requisição recém gerada no sistema.'
                            )"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de encaminhamento do boleto, termo de parcelamento e memória de cálculo da Requisição'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailEncaminhamentoBoleto"
                                  :options="editorOption">
                                  :class="'text-label required ' + (!paymentValidations.emailEncaminhamentoBoleto.valid ? 'is-invalid' : '')"

                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailEncaminhamentoBoleto.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        E-mail de encaminhamento mensal dos boletos do parcelamento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('E-mail de encaminhamento mensal dos boletos do parcelamento', 'Texto a ser incluído no e-mail mensal de encaminhamento ao devedor dos boletos das parcelas a serem por ele pagas naquele mês.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de encaminhamento mensal dos boletos do parcelamento'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailEncaminhamentoMensal"
                                  :options="editorOption">
                                  :class="'text-label required ' + (!paymentValidations.emailEncaminhamentoMensal.valid ? 'is-invalid' : '')"
                                  
                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailEncaminhamentoMensal.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        E-mail de parcela aguardando pagamento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo(
                               'E-mail de parcela aguardando pagamento',
                               'Texto a ser incluído no e-mail de aviso ao devedor à respeito de parcela emitida, encaminhada ao devedor naquele mês e ainda aguardando pagamento, prestes a vencer.'
                            )"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de parcela aguardando pagamento'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailBoletoAtrasado"
                                  :options="editorOption">
                                  :class="'text-label required ' + (!paymentValidations.emailBoletoAtrasado.valid ? 'is-invalid' : '')"
                                  
                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailBoletoAtrasado.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        E-mail de rescisão do parcelamento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('E-mail de rescisão do parcelamento', 'Texto a ser incluído no e-mail de aviso ao devedor sobre a rescisão do parcelamento.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de rescisão do parcelamento'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailRescisao"
                                  :options="editorOption">
                                  :class="'text-label required ' + (!paymentValidations.emailRescisao.valid ? 'is-invalid' : '')"
                                  
                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailRescisao.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        E-mail de comunicação de Invalidação da Requisição de Transferência pelo Tesoureiro/GOFS:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo(
                               'E-mail de comunicação de Invalidação da Requisição de Transferência pelo Tesoureiro/GOFS',
                               'Texto a ser incluído no e-mail de comunicação ao usuário emissor de uma Requisição do tipo Comunicação de Transferência invalidada pelo Tesoureiro do Fundo ou pelo GOFS.'
                            )"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de rescisão do parcelamento'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailInvalidacaoGofs"
                                  :options="editorOption">
                                  :class="'text-label required ' + (!paymentValidations.emailInvalidacaoGofs.valid ? 'is-invalid' : '')"
                                  
                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailInvalidacaoGofs.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
	                    E-mail de encaminhamento do boleto de Protesto:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo(
                               'E-mail de encaminhamento do boleto de Protesto',
                               'Texto a ser incluído no e-mail de encaminhamento ao devedor do boleto de Protesto relativo à Requisição recém gerada no sistema.'
                            )"
                           v-b-popover.hover.top="'Clique para saber mais sobre E-mail de encaminhamento do boleto de Protesto'"></i>
                    </p>
                    <quill-editor v-model="parametros.emailEncaminhamentoBoletoProtesto"
                                  :options="editorOption"
                                  :class="'text-label required ' + (!paymentValidations.emailEncaminhamentoBoletoProtesto.valid ? 'is-invalid' : '')">
                    </quill-editor>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.emailEncaminhamentoBoletoProtesto.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
            </b-row>
            <hr class="mt-2"/>
            <b-row class="center-xy">
                <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                    <i class="fa fa-reply"></i> Voltar
                </b-button>
                <b-button variant="primary" class="ml-2" @click="verificarSalvar">
                    <i class="far fa-save"></i> Salvar
                </b-button>
            </b-row>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                hea1w11111der-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja retornar à tela anterior sem salvar as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja salvar as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info"
                id="modal-info"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="titleInfo"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">{{textoInfo}}</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import formatarMixins from '../../mixins/formatarMixins'
import CompLoading from "../shared/components/CompLoading";
import {quillEditor} from 'vue-quill-editor'

export default {
        components: {quillEditor, CompLoading, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                parametros: {
                    emailCes: null,
	                emailCesTransf: null,
                    emailEncaminhamentoBoleto: null,
                    emailEncaminhamentoMensal: null,
                    emailBoletoAtrasado: null,
                    emailRescisao: null,
                    emailInvalidacaoGofs: null,
	                emailEncaminhamentoBoletoProtesto: null
                },
                titleInfo: '',
                textoInfo: '',
                existeRegistro: false,
                editorOption: {
                    placeholder: '',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link', 'image', 'video']
                        ],
                        syntax: {
                            highlight: text => hljs.highlightAuto(text).value
                        }
                    }
                },
                content: '',
                
                paymentValidations: {
                    emailCes: { valid: true, message: ""},
	                emailCesTransf: { valid: true, message: ""},
                    emailEncaminhamentoBoleto: { valid: true, message: ""},
                    emailEncaminhamentoMensal: { valid: true, message: ""},
                    emailBoletoAtrasado: { valid: true, message: ""},
                    emailRescisao:  { valid: true, message: ""},
                    emailInvalidacaoGofs:  { valid: true, message: ""},
	                emailEncaminhamentoBoletoProtesto:  { valid: true, message: ""}
                    
                    },
                
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        
        
                    
        methods: {
            verificarSalvar() {
                if(!this.validaremailEncaminhamentoBoletoValorObrigatorio(this.emailEncaminhamentoBoleto)|
                   !this.validaremailEncaminhamentoMensalValorObrigatorio(this.emailEncaminhamentoMensal)|
                   !this.validaremailBoletoAtrasadoValorObrigatorio(this.emailBoletoAtrasado)|
                   !this.validaremailRescisaoValorObrigatorio(this.emailRescisao)|
                   !this.validaremailInvalidacaoGofsValorObrigatorio(this.emailInvalidacaoGofs)|
                   !this.validarEmailCesObrigatorio(this.emailCes)|
                   !this.validarEmailCesTransfObrigatorio(this.emailCesTransf)|
                   !this.validarEmailProtestoObrigatorio(this.emailEncaminhamentoBoletoProtesto)) {
                    
                    return;
                }

                this.$refs['modal-salvar'].show();
            },
            
            validaremailEncaminhamentoBoletoValorObrigatorio() {
                
                if(this.parametros.emailEncaminhamentoBoleto == null | this.parametros.emailEncaminhamentoBoleto == "") {
                    this.validarCampoObrigatorio(this.parametros.emailEncaminhamentoBoleto, this.paymentValidations.emailEncaminhamentoBoleto)
                    return this.paymentValidations.emailEncaminhamentoBoleto.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.emailEncaminhamentoBoleto.valid=true;
                    
                }
                
             }, 
             
             validaremailEncaminhamentoMensalValorObrigatorio() {
                
                if(this.parametros.emailEncaminhamentoMensal == null | this.parametros.emailEncaminhamentoMensal == "") {
                    this.validarCampoObrigatorio(this.parametros.emailEncaminhamentoMensal, this.paymentValidations.emailEncaminhamentoMensal)
                    return this.paymentValidations.emailEncaminhamentoMensal.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.emailEncaminhamentoMensal.valid=true;
                    
                }
                
             }, 
             
             validaremailBoletoAtrasadoValorObrigatorio() {
                
                if(this.parametros.emailBoletoAtrasado == null | this.parametros.emailBoletoAtrasado == "") {
                    this.validarCampoObrigatorio(this.parametros.emailBoletoAtrasado, this.paymentValidations.emailBoletoAtrasado)
                    return this.paymentValidations.emailBoletoAtrasado.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.emailBoletoAtrasado.valid=true;
                    
                }
                
             }, 
             
             validaremailRescisaoValorObrigatorio() {
                
                if(this.parametros.emailRescisao == null | this.parametros.emailRescisao == "") {
                    this.validarCampoObrigatorio(this.parametros.emailRescisao, this.paymentValidations.emailRescisao)
                    return this.paymentValidations.emailRescisao.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.emailRescisao.valid=true;
                    
                }
                
             }, 
             
               validaremailInvalidacaoGofsValorObrigatorio() {
                
                if(this.parametros.emailInvalidacaoGofs == null | this.parametros.emailInvalidacaoGofs == "") {
                    this.validarCampoObrigatorio(this.parametros.emailInvalidacaoGofs, this.paymentValidations.emailInvalidacaoGofs)
                    return this.paymentValidations.emailInvalidacaoGofs.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.emailInvalidacaoGofs.valid=true;
                    
                }
                
             },

            validarEmailCesObrigatorio() {
                if (this.isEmpty(this.parametros.emailCes)) {
                    this.validarCampoObrigatorio(this.parametros.emailCes, this.paymentValidations.emailCes)
                    return this.paymentValidations.emailCes.valid = false;
                } else {
                    return this.paymentValidations.emailCes.valid = true;
                }
            },

            validarEmailProtestoObrigatorio() {
                if (this.isEmpty(this.parametros.emailEncaminhamentoBoletoProtesto)) {
                    this.validarCampoObrigatorio(this.parametros.emailEncaminhamentoBoletoProtesto, this.paymentValidations.emailEncaminhamentoBoletoProtesto)
                    return this.paymentValidations.emailEncaminhamentoBoletoProtesto.valid = false;
                } else {
                    return this.paymentValidations.emailEncaminhamentoBoletoProtesto.valid = true;
                }
            },

	        validarEmailCesTransfObrigatorio() {
		        if (this.isEmpty(this.parametros.emailCesTransf)) {
			        this.validarCampoObrigatorio(this.parametros.emailCesTransf, this.paymentValidations.emailCesTransf)
			        return this.paymentValidations.emailCesTransf.valid = false;
		        } else {
			        return this.paymentValidations.emailCesTransf.valid = true;
		        }
	        },

            salvar() {
                this.$refs['modal-salvar'].hide();

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/parametros/salvar`, this.parametros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    this.$router.push({path: '/home'});
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            openInfo(title, text) {
                this.titleInfo = title;
                this.textoInfo = text;
                this.$refs['modal-info'].show();
            },

            verificarObrigatoriedade() {
                return !(this.verificarValorVazio(this.parametros.emailEncaminhamentoBoleto) ||
                    this.verificarValorVazio(this.parametros.emailEncaminhamentoMensal) ||
                    this.verificarValorVazio(this.parametros.emailBoletoAtrasado) ||
                    this.verificarValorVazio(this.parametros.emailRescisao) ||
                    this.verificarValorVazio(this.parametros.emailInvalidacaoGofs));
            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/'});
            },

            async obterParametro() {
                await axios.get(`${this.urlApi}/v1/parametros/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.parametros = response.data;
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.obterParametro();
        }
    }
</script>
<style>
    .multiselect-simple .multiselect__content-wrapper .multiselect__content .multiselect__element span:before {
        display: none;
    }

    .text-danger {
        margin-right: 10px;
    }
</style>